import { AIIcon } from 'library/icons';
import { ComponentPropsWithoutRef, FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface AIAvatarProps extends ComponentPropsWithoutRef<'div'> {
    size: number;
    animate?: boolean;
    showIcon?: boolean;
}
const AIAvatar: FC<AIAvatarProps> = (props) => {
    const { size, animate = false, showIcon = true, className, style = {}, ...rest } = props;

    return (
        <div
            {...rest}
            className={twMerge(
                'flex items-center justify-center rounded-full ai-gradient text-white',
                className,
                animate ? 'ai-gradient-animate' : ''
            )}
            style={{ width: size, height: size, minWidth: size, minHeight: size, ...style }}
        >
            {showIcon && <AIIcon width={size / 2.4} height={size / 2.4} />}
        </div>
    );
};

export default AIAvatar;
